module.exports = ".img-circle.profile_img {\n  margin-top: -30px;\n  margin-left: 0px; }\n\n.margin_bottom {\n  margin-bottom: 20px;\n  border-top: 1px solid #e6e6e6;\n  padding-top: 20px;\n  padding-left: 0px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/corporate-partner/corporate-partner.component.scss
// module id = ./src/app/admin/corporate-partner/corporate-partner.component.scss
// module chunks = main